// Get Creator Signals
export const GET_CREATOR_SIGNALS_REQUEST = 'GET_CREATOR_SIGNALS_REQUEST';
export const GET_CREATOR_SIGNALS_DONE = 'GET_CREATOR_SIGNALS_DONE';
export const GET_CREATOR_SIGNALS_FAILED = 'GET_CREATOR_SIGNALS_FAILED';

export const GET_CREATOR_SIGNALS_RESET = 'GET_CREATOR_SIGNALS_RESET';
